import { Component, OnInit } from "@angular/core";
import { IViewMetadata } from "@tylertech/tyler-api-types";
import { MetadataViewService, RepositoryFormData, } from "@tylertech/metadata-module";
import { DashboardMetadataService } from "../../services";

@Component({
    selector: "dashboard-metadata",
    templateUrl: "./dashboardMetadata.tmpl.html",
    standalone: false
})
export class DashboardMetadataComponent implements OnInit
{
    datacontroller: RepositoryFormData;
    view: IViewMetadata;
    loaded: boolean = false;

    constructor(
        private readonly $metadataViewService: MetadataViewService,
        private readonly $dashboardMetadataService: DashboardMetadataService
    ) { }

    ngOnInit(): void
    {
        const self = this;
        self.$dashboardMetadataService.GetDashboardMetadataView()
            .then(r =>
            {
                if (r)
                {
                    self.view = r;
                    const typeName = self.$metadataViewService.GetTypeName(self.view);
                    self.datacontroller = new RepositoryFormData(typeName, null);
                    self.loaded = true;
                }
            });
    }
}
